module.exports = __webpack_public_path__ + "resources/img/logo_footer_nhn.c18087aac97aa4636596b387f1b7b7c9.png";